import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import { Amplitude, LogOnMount } from "react-amplitude-hooks";
import { toTop, getVh } from "components/Travel/function";
import { Title, TitleBox, HistoryContainer } from "style/components";
import SubscriptionFooter from "./footer";

import SubscriptionListCard from "components/Travel/Mobile/Subscription/card";
interface Props {
  match: any;
}

const SubscriptionList: React.FunctionComponent<Props> = ({ match }) => {
  const [data, setData] = useState([]);
  const [isData, setIsData] = useState(false);
  useEffect(() => {
    toTop();
    getVh();
    if (!isData) {
      if (sessionStorage.getItem("subscription")) {
        const subscriptionData: string =
          sessionStorage.getItem("subscription") || "";
        if (subscriptionData) {
          setIsData(true);
          setData(JSON.parse(subscriptionData));
        }
      } else {
        window.location.replace("/travel/mrt/subscription");
      }
    }
  }, [isData]);
  return (
    <Amplitude>
      <LogOnMount eventType="history_list" />
      <HistoryContainer className="listPage">
        <TitleBox>
          <Title>가입내역</Title>
        </TitleBox>
        {isData && (
          <LastTripList>
            {data.map((card: any, index: number) => (
              <SubscriptionListCard
                key={card.no}
                index={index}
                data={card}
                match={match}
              />
            ))}
          </LastTripList>
        )}
      </HistoryContainer>
      <SubscriptionFooter />
    </Amplitude>
  );
};

const LastTripList = styled.div`
  margin-bottom: 50px;
  border-bottom: 1px solid ${props => props.theme.colors.divider2};
`;

export default SubscriptionList;
